import { objectToImageChoices } from '@shared/choice';
import { LITTLE_GATE_SIZE_IMAGES_AND_TRAD_KEYS } from '@shared/constants/externalDamages';
export const LITTLE_GATE_MATERIAL_TITLE = 'claim.declaration.external_damages.form.little_gate.material.title';
export const LITTLE_GATE_MATERIAL_PLACEHOLDER = 'claim.declaration.external_damages.form.little_gate.material.placeholder';
export const LITTLE_GATE_SIZE_TITLE = 'claim.declaration.external_damages.form.little_gate.size.title';
export const LITTLE_GATE_SIZE_SUBTITLE = 'claim.declaration.external_damages.form.little_gate.size.subtitle';
export const LITTLE_GATE_SIZE_CHOICES = objectToImageChoices(LITTLE_GATE_SIZE_IMAGES_AND_TRAD_KEYS);
